import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { getLocalizedNumberOfPayingTeams } from "constants/localized-number-of-customers";
import { componentStyle, signupBoxStyle } from "./exit-popup-signup-component.scss";
class ExitPopupSignup extends PureComponent {
    onInputChange(e) {
        const { value } = e.target.value;
        this.setState({
            value
        });
    }
    render() {
        const { headerText, inputPlaceholder, buttonText, footerText, origin, onClickFooterText } = this.props;
        const { value } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${signupBoxStyle.__hash} jsx-${componentStyle.__hash}` + " " + "exit-popup-signup",
            children: [
                headerText && /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${signupBoxStyle.__hash} jsx-${componentStyle.__hash}` + " " + "header-text",
                    children: headerText
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${signupBoxStyle.__hash} jsx-${componentStyle.__hash}` + " " + "exit-popup-signup-box",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        placeholder: inputPlaceholder,
                        ctaText: buttonText,
                        useCtaText: !!buttonText,
                        origin: origin,
                        forceDefaultForm: true
                    })
                }),
                footerText && /*#__PURE__*/ _jsx("div", {
                    onClick: onClickFooterText,
                    className: `jsx-${signupBoxStyle.__hash} jsx-${componentStyle.__hash}` + " " + "footer-text",
                    children: footerText
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyle.__hash,
                    children: componentStyle
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: signupBoxStyle.__hash,
                    children: signupBoxStyle
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            value: ""
        };
        this.onInputChange = this.onInputChange.bind(this);
    }
}
export { ExitPopupSignup as default };
ExitPopupSignup.defaultProps = {
    headerText: `Join <monday-paying-companies />+ teams who are passionate about monday.com`,
    buttonText: "Get free access now",
    inputPlaceholder: "Enter your work email",
    footerText: "No thanks"
};
